import { useMemo } from 'react';

import type { ShareConfig } from '../shared/types';

type SyncShareChannel = never; // TODO omit async channels like gmail from ShareChannel

export function useSyncAvailableShareChannels(_config: ShareConfig): Readonly<Record<SyncShareChannel, boolean>> {
	// const gmail = useGmail(); // gmail will need user info + fcm info

	return useMemo(
		() => ({
			// TODO
			// gmail
		}),
		[],
	);
}
